import styled, { keyframes } from 'styled-components';

import { RATE_IT_COLORS, RATE_IT_LAYOUT } from '../constants';

const shimmer = keyframes`
  0% { opacity: 0.35; }
  50% { opacity: 0.6; }
  100% { opacity: 0.35; }
`;

const Frame = styled.div`
  position: absolute;
  inset: 0;
  background-color: ${RATE_IT_COLORS.CARD_BG};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const Block = styled.div`
  background: rgba(255, 255, 255, 0.08);
  border-radius: ${RATE_IT_LAYOUT.TILE_RADIUS}px;
  animation: ${shimmer} 1.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const BarRow = styled.div`
  display: flex;
  gap: ${RATE_IT_LAYOUT.TILE_GAP}px;
  padding: ${RATE_IT_LAYOUT.BAR_PADDING_VERTICAL}px ${RATE_IT_LAYOUT.BAR_GUTTER}px 32px;
`;

const TileGhost = styled(Block)`
  flex: 1;
  height: ${RATE_IT_LAYOUT.TILE_HEIGHT}px;
`;

/**
 * The trailing placeholder, shown only while the next random draw is in flight.
 *
 * Exists so swiping past the last loaded moment lands on something rather than a dead end. It
 * mirrors the bar's geometry so the layout does not jump when the real card replaces it.
 */
const RateItItemSkeleton = () => (
  <Frame aria-hidden>
    <BarRow>
      <TileGhost />
      <TileGhost />
      <TileGhost />
    </BarRow>
  </Frame>
);

export default RateItItemSkeleton;
